import { Box } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Text from "../../components/ui/Text";
import apiService from "../../services/api";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const sendResetEmail = async () => {
    await apiService.forgotPassword(email);
  };

  useEffect(() => {
    if (!email) {
      // If no email in state, redirect to signin
      navigate("/signin");
    } else {
      sendResetEmail();
    }
  }, [email]);

  return (
    <Box>
      <Text variant="pageHeader" sx={{ mb: "8px !important" }}>
        Reset your password
      </Text>
      <Text component="p" sx={{ mb: 2 }}>
        We've upgraded our systems to improve your experience and security.
      </Text>
      <Text component="p">
        To continue, please <b>reset your password.</b>
      </Text>
      <Text component="p" sx={{ mb: 2 }}>
        What to do:
      </Text>
      <Box component="ol" sx={{ pl: 3, mb: 2 }}>
        <Text component="li">
          Check your inbox for an email from Findaside.
        </Text>
        <Text component="li">
          Click the "Reset password" button inside to reset your password and
          log back in.
        </Text>
      </Box>
      <Text component="p">
        If you don't see the email, check your spam or promotions folder.
      </Text>
    </Box>
  );
};

export default ResetPassword;
